<template id="modal-template">
    <transition v-if="show" name="modal" appear>
        <div class="modal-container modal-container--view-image">
            <div class="modal-wrapper">
                <div class="modal">
                    <div class="modal__body">
                        <div class="interior-modal">
                            <div class="interior-modal__left">
                                <!-- 이미지 슬라이드 -->
                                <div class="compare-grid__images">
                                    <div class="compare-slide">
                                    <!-- 썸네일: Before -->
                                        <div class="image">
                                            <img class="thumb" :src="portfolio.spaces[selectedIndex].beforeImage" alt="">
                                        </div>
                                        <!-- 썸네일: After -->
                                        <div class="image image-overlay2">
                                            <img class="thumb" :src="portfolio.spaces[selectedIndex].afterImage" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="interior-modal__right">
                                <div class="interior-modal__buttons">
                                    <!-- 버튼 활성화 서브클래스: button--active -->
                                    <button class="button button--scrap">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <path fill-rule="evenodd" stroke-width="2.2px" stroke-linecap="butt" stroke-linejoin="round" fill="none" d="M22.100,14.100 L4.100,28.100 L4.100,4.100 L22.100,4.100 L22.100,28.100 L13.100,22.100 "></path>
                                        </svg>
                                        <span class="blind">스크랩</span>
                                    </button>
                                    <button class="button button--close" type="button" @click="close()"></button>
                                </div>

                                <div class="interior-modal__link">
                                    <a class="button button--primary" :href="`/portfolio/resident/${portfolio._id}`">
                                        <span>현재 사진 포함 전체 인테리어</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8.5px" height="15.5px">
                                            <path fill-rule="evenodd"  stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M1.500,1.500 L7.500,7.500 L1.500,13.500 "/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            <div class="interior-modal__bottom">
                                <ul class="interior-list__tags">
                                    <li class="interior-list__tag" v-for="tag in portfolio.spaces[selectedIndex].tags" :key="tag"><span>#{{ tag }}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="modal__foot modal__foot-no-border">
                        <div class="modal__buttons modal__buttons--narrow">
                            <a class="button button--border-primary" href="" onclick="return false;" @click="$emit('close')"><span>쇼핑계속하기</span></a>
                            <a class="button button--primary" href="/mypage/cart"><span>장바구니 가기</span></a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            show: false,

            portfolio: null,
            selectedIndex: null
        }
    },
    mounted() {
        this.component = this;
    },
    methods: {
        open(){
            this.selectedIndex = this.portfolio.spaceIndex;
            this.show = true;
            this.$nextTick(() => {
                this.compareSlider();
            })
        },
        close(){
            this.show = false;
        },
        compareSlider() {
            var x, i;
            x = document.querySelector(".image-overlay2");
            console.log(x);
            // x.style.opacity = "0.5";
            try{
                compareImages(x);

            }catch(error) {
                console.error(error);
            }
            function compareImages(img) {
                var slider, img, clicked = 0, w, h;

                w = img.offsetWidth;
                h = img.offsetHeight;

                img.style.width = (w / 2) + "px";

                slider = document.createElement("DIV");
                slider.setAttribute("class", "controller");

                img.parentElement.insertBefore(slider, img);

                slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";

                slider.addEventListener("mousedown", slideReady);
                window.addEventListener("mouseup", slideFinish);
                slider.addEventListener("touchstart", slideReady, {passive: true});
                window.addEventListener("touchend", slideFinish);

                function slideReady(e) {
                    // e.preventDefault();
                    clicked = 1;

                    window.addEventListener("mousemove", slideMove);
                    window.addEventListener("touchmove", slideMove);
                }
                function slideFinish() {
                    clicked = 0;
                }
                function slideMove(e) {
                    var pos;

                    if (clicked == 0) return false;

                    pos = getCursorPos(e)

                    if (pos < 0) pos = 0;
                    if (pos > w) pos = w;

                    slide(pos);
                }
                function getCursorPos(e) {
                    var a, x = 0;
                    e = e || window.event;
                    a = img.getBoundingClientRect();

                    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                        var touchX = 0;
                        for (i=0; i < e.changedTouches.length; i++) {
                            touchX = e.changedTouches[i].pageX - a.left;
                            touchX = touchX - window.pageXOffset;
                        }
                        return touchX;
                    }else{
                        x = e.pageX - a.left;
                        x = x - window.pageXOffset;
                        return x;
                    }
                }
                function slide(x) {
                    img.style.width = x + "px";
                    slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
                }
            }
        }
    }
}
</script>
